<div class="pr-tainer reminder-sets-page">
  <div class="container">
    <div class="header-row">
      <div>
        <h3 class="page-title">Reminder sets</h3>
        <p class="section-desc">Reminder Sets are a way to manage reminders for different patient sets.</p>
      </div>
      <button class="fab" aria-label="Add reminder set" (click)="addReminderSet()">
        <span>+</span>
      </button>
    </div>
    <div class="reminder-sets-empty">No reminder sets exist.</div>
  </div>
</div>
<!-- Add Reminder Set Modal (top-level overlay) -->
<ng-container *ngIf="showAddReminderSetModal">
  <div class="modal-backdrop">
    <div class="modal add-reminderset-modal">
      <div class="modal-header">
        <span class="modal-title">Add Reminder Set</span>
        <button class="modal-close" (click)="closeAddReminderSetModal()">&times;</button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="reminderSetToEdit">
          <form (ngSubmit)="saveNewReminderSet()">
            <div class="modal-form-row">
              <label for="reminderSetTitleModal">*Name</label>
              <input id="reminderSetTitleModal" name="reminderSetTitleModal" type="text" maxlength="100" [(ngModel)]="reminderSetToEdit.title" required />
            </div>
            <div class="modal-form-row">
              <label for="reminderSetDescriptionModal">Short description</label>
              <textarea id="reminderSetDescriptionModal" name="reminderSetDescriptionModal" maxlength="300" [(ngModel)]="reminderSetToEdit.description"></textarea>
              <div class="char-count">Maximum 300 characters : <span class="char-remaining">{{300 - (reminderSetToEdit.description?.length || 0)}} remaining</span></div>
            </div>
          </form>
        </ng-container>
      </div>
      <div class="modal-footer">
        <button class="modal-cancel" (click)="closeAddReminderSetModal()">Cancel</button>
        <button class="modal-save" (click)="saveNewReminderSet()">Save</button>
      </div>
    </div>
  </div>
</ng-container>
